import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { TariffPollSuccessDialogProps } from './TariffPollSuccessDialog.types';

export const renderTariffPollSuccessModal = (data?: TariffPollSuccessDialogProps) =>
    openPopupHelper({ popupName: popupNames.TARIFF_POLL_SUCCESS_MODAL, data });
